
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'upload',
    templateUrl: 'upload-attachment.component.html',
  standalone: false
})
export class uploadComponent implements OnInit {
    constructor() { }
    
    ngOnInit() {
        document.querySelector("body").classList.remove("opened");
    }
     
}